import "./styles/global.css";
import Header from "./components/Header";
import MainContainer from "./components/MainContainer";

function App() {
  return (
    <div className="app">
      <Header />
      <MainContainer />
    </div>
  );
}

export default App;
